import { createBaseResourceActions } from '../create-base-resource-actions';
import { UserRoleAssignmentResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[USER ROLE ASSIGNMENT]';
export const userRoleAssignmentActions =
  createBaseResourceActions<UserRoleAssignmentResourceTypeMappings>(domainSlug);
